import StockSearchItemBase from "@/classes/stock/StockSearchItemBase";

export default class StockSearchItem extends StockSearchItemBase {
    constructor() {

        super()

        // this.showZeroQuantities = true;
        this.warehouseRef = '';
        this.jobRef = '';
        this.customerRef = '';
        this.deliverTo = '';
        this.completed = false;
        this.notification = false;
        this.releaseDateFrom = '';
        this.releaseDateTo = '';
        this.releasedBy = '';
        this.soNumber = '';
        this.jobRef = '';

    }
}
